import { gql } from '@apollo/client'
import { ComplementProcedureFragment } from '../fragment/complementProcedure.fragment'

export const COMPLEMENT_PROCEDURE_QUERY = gql`
  query ComplementProcedure($demandeId: bigint!) {
    procedure: d4_demande_by_pk(id: $demandeId) {
      id
      description
      complementprocedure {
        ...ComplementProcedure
        avocat {
          id
          raisonsociale
        }
      }
    }
  }
  ${ComplementProcedureFragment}
`
